import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, catchError, of } from 'rxjs';
import { AuthenticationService } from '../services/Authentication/authentication.service';
import { WebSocketService } from '../services/web-socket.service';

export const authGuard: CanActivateFn = (route, _state) => {
  const authService = inject(AuthenticationService);
  const webSocketService = inject(WebSocketService);
  const router = inject(Router);

  const emailParam = route.queryParams['email'];

  if (emailParam) {
    return authService.directEmailLogin(emailParam).pipe(
      map((success) => {
        if (success) {
          webSocketService.init();
          return true;
        }
        if (authService.getAccessToken()) {
          webSocketService.init();
          return true;
        }
        return router.createUrlTree(['/authentication']);
      })
    );
  }

  if (authService.getAccessToken()) {
    webSocketService.init();
    return true;
  }

  return authService.loginGuest().pipe(
    map((success) => {
      if (success) {
        webSocketService.init();
        return true;
      }
      return router.createUrlTree(['/authentication']);
    }),
    catchError(() => of(router.createUrlTree(['/authentication'])))
  );
};

